export default '/build/e2667b95.svg'